module.exports = __webpack_public_path__ + "static/media/logo-white.9fd49e04.png";